import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const ExpenseDetail = lazyLoader(
  () => import("Containers/Expense/ExpenseDetail/ExpenseDetail"),
);
export const ExpenseDetailPage = () => {
  return (
    <Layout>
      <ExpenseDetail />
    </Layout>
  );
};
